import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ElectionClient, ElectionDto, ElectionsOverviewDto } from '@shared/clients/api.generated';
import { ElectionOverviewBaseComponent } from '@shared/components/election-overview-base/election-overview-base.component';
import { DateService } from '@shared/services/date-service.service';
import { FooterLinkService } from '@shared/services/footerlink.service';
import { FooterLink } from '@valg-shared/components/footer/footer.component';

export interface ElectionLink {
  href: string;
  title: string;
}

@Component({
  selector: 'valg-dk-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: [ 'site-map.component.scss' ]
})
export class SiteMapComponent extends ElectionOverviewBaseComponent implements OnInit {
  footerLinks: FooterLink[] = [];
  elections: ElectionDto[] = [];

  constructor(
    private readonly electionClient: ElectionClient,
    protected override readonly router: Router,
    protected override readonly dateService: DateService,
    private readonly footerService: FooterLinkService) {
    super(router, dateService);
  }

  ngOnInit(): void {
    this.electionClient.getAllElections().subscribe((results: ElectionsOverviewDto) => {
      this.electionsOverview = results;
      this.elections = this.electionTypes.map(type => this.getElections(type) ?? []).flat();
    })
    this.footerLinks = this.footerService.getFooterLinks();
    
  }

  getFormattedElection(election: ElectionDto) {
    return `${election.electionName} ${new Date(election.electionDate).getFullYear()}
      - ${this.formatElectionDate(election.electionDate)}`
  }

  getElectionHref(election: ElectionDto) {
    return `${this.electionIdentifier[election.electionType]}/${election.id}`
  }
}
